import { useCallback, useRef } from 'react';

export function useRefCallback<TArgs extends unknown[], TReturn>(
    fn: (...args: TArgs) => TReturn,
): (...args: TArgs) => TReturn {
    const ref = useRef(fn);
    ref.current = fn;

    return useCallback((...args: TArgs) => ref.current(...args), []);
}
